const frameLockModes = {
    NONE: 'LOCKED_NONE',
    POSITION: 'LOCKED_POSITION',
};

export default frameLockModes;
